import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { GeneralService } from '../../../services/formulacion/general.service';
import { switchMap } from 'rxjs/operators';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
import number_box from 'devextreme/ui/number_box';

@Component({
  selector: 'app-rpt-general',
  templateUrl: './rpt-general.component.html',
  styleUrls: [],
  providers: [GeneralService]
})
export class RptGeneralComponent implements OnInit {
  gestiones: any = [];
  etapas: any = [];
  de = true;
  gestion: string = '';
  etapa: string = '';
  baseUrl = environment.apiEndpoint;
  rol: number = 0;
  unidad: number = 0;
  techos: any;
  tipo_agregacion_id: number = 1;
  reportes: any = [
    
    { id: 1, reporte: 'Traspasos detalle por Partida Presupuestaria', url: this.baseUrl + 'xls/partidasTraspasos/' },
    { id: 2, reporte: 'Programación presupuestaria por Categoría Programática', url: this.baseUrl + 'xls/panzaByCatProg/' },
    { id: 3, reporte: 'Formato Unidad Financiera Formulacion POA', url: this.baseUrl + 'xls/getXlsFormatoUfinPoa/' },
    { id: 4, reporte: 'Avances Reportados para el seguimiento Físico de Ejecución al POA', url: this.baseUrl + 'xls/avanceFisico/' },
    { id: 5, reporte: 'Reporte General FUS', url: this.baseUrl + 'xls/seguimientoGeneralFUS/' },
    { id: 6, reporte: 'Reporte General Traspasos', url: this.baseUrl + 'xls/seguimientoGeneralTraspasos/' },    

  ];
  vdg: boolean = true;

  constructor(private _gs: GeneralService) {
    this.getPoaGestiones();
    this.getTechoByUO();
    let u = JSON.parse(localStorage.getItem('u'));
    if (u != null) {
      this.rol = u.rol;
      this.unidad = u.unidad;
      this.tipo_agregacion_id = 1; 
    }
  }

  getTechoByUO() {
    this._gs.getTechoByUO(this.unidad).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.techos = result.data;

        } else {
          this.techos = [];
        }
      },
      (error) => { console.log('Error', error); });

  }

  ngOnInit() {
  }

  getPoaGestiones() {
    this._gs.getPoaGestiones().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.gestiones = result.data; }
        else { this.gestiones = []; }
      },
      (error) => { console.log('Error', error); });
  }

  getEtapasByGestionId(e: any) {
    if (e.value != undefined && e.value != null) {
      this._gs.getEtapasByGestionId(e.value).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.etapas = result.data;
            this.gestion = e.value;
          }
          else { this.etapas = []; }
        },
        (error) => { console.log('Error', error); });      
    }
  }

  getReportes(e: any) {
    if (e.value != undefined && e.value != null) {
      this.etapa = e.value;
      this.vdg = true;
    }
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    });
  }

}
